import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
import 'datatables.net-bs4/js/dataTables.bootstrap4.min.js';
import useAuth from '../../component/useAuth';
import Template from '../../component/Template';
import { useEffect } from 'react';
import Api from '../../component/Api';
import { useState } from 'react';
import '../../Assets/css/vendors/datatables.css';
import { useRef } from 'react';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';
import '../../Assets/css/kebabMenu.css';

export default function Syllabus() {
    const [syllabuslisting, setSyllabuslistingData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);

    const [totalsyllabus, setTotalsyllabus] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [filteredAndSortedData, setfilteredAndSortedData] = useState([]);

    const [retryAttempt, setRetryAttempt] = useState(0);
    const tableRef = useRef(null);
    const [istost, settost] = useState(false);
    const [discipline, setDiscipline] = useState([]);
    const [semester, setSemester] = useState(false); 
    const [selectedDiscipline, setSelectedDiscipline] = useState(null);
    const [message, setMessage] = useState(false);

    const isAuth = useAuth()
    const navigate = useNavigate();
    if (isAuth === false) {
        navigate("/admin/")
    }

    const encodeID = id => {
        return btoa(id);
    };

    const handleSearchInputChange = (event) => {
        setSearchQuery(event.target.value);
    };

    useEffect(() => {
        settost(sessionStorage.getItem("message"));
        const fetchData = async () => {
            try {
                setMessage(false);
                const { http } = Api();

                const response = await http.get(`/Admin/syllabuslisting?page=${currentPage}`, {
                    params: {
                        limit: '50',
                        discipline_id: selectedDiscipline
                    }
                });

                const response1 = await http.get(`/Admin/getdiscipline`);
                setDiscipline(response1.data.data);
                const response5 = await http.get('/Admin/getsemester');
                setSemester(response5.data);

                if (response.data.data.length === 0) {
                    setMessage("Data not available");
                } else {
                    setSyllabuslistingData(response.data.data);
                    setTotalsyllabus(response.data.total);
                    setTotalPages(Math.ceil(response.data.total / 50));
                }

            } catch (error) {
                setMessage("No Data Avaliable");
                const delay = Math.pow(2, retryAttempt) * 1000;
                setTimeout(() => {
                    setRetryAttempt(retryAttempt + 1);
                }, delay);
                console.error('Error fetching syllabus data:', error);
            }
        };

        fetchData();

    }, [retryAttempt, currentPage, selectedDiscipline]);

    useEffect(() => {
        if (istost) {
            toast.success(istost);
            sessionStorage.removeItem("message");
            settost(false);
        }
    }, [istost]);

    useEffect(() => {
        const filteredAndSortedData = [...syllabuslisting].filter(syllabuslistings => {
            return (
              syllabuslistings.course_name.toLowerCase().includes(searchQuery.toLowerCase()) ||
              syllabuslistings.course_discipline_component_code.toLowerCase().includes(searchQuery.toLowerCase())
            );
        })
        setfilteredAndSortedData(filteredAndSortedData);
    }, [searchQuery, syllabuslisting]);

    const handleNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const handlePreviousPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const groupedBySemester = filteredAndSortedData.reduce((acc, course) => {
        const semester = course.semester_id;
        if (!acc[semester]) {
            acc[semester] = [];
        }
        acc[semester].push(course);
        return acc;
    }, {});

    const handleDisciplineChange = selectedOption => {
        setSelectedDiscipline(selectedOption);
        setCurrentPage(1);
    };

    const customStyles = {
        menu: (provided) => ({
          ...provided,
          maxHeight: '200px',
          overflowY: 'auto',
        }),
        menuList: (provided) => ({
          ...provided,
          maxHeight: '200px',
          overflowY: 'auto',
          scrollbarWidth: 'thin',
          scrollbarColor: '#888 #f1f1f1',
        }),
        /* Additional custom scrollbar styling for WebKit-based browsers */
        multiValue: (provided) => ({
          ...provided,
          '&::-webkit-scrollbar': {
            width: '8px',
          },
          '&::-webkit-scrollbar-track': {
            background: '#f1f1f1',
          },
          '&::-webkit-scrollbar-thumb': {
            background: '#888',
            borderRadius: '4px',
          },
          '&::-webkit-scrollbar-thumb:hover': {
            background: '#555',
          },
        }),
      };

    return (
        <>
            <Template>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-header">
                                    <div className="py-3 d-flex justify-content-between align-items-center ">
                                        <h5>Syllabus</h5>
                                    </div>
                                </div>
                                <div className="card-body">
                                    <div className="card-body pdg1">
                                        <div className="col-md-4 pdg10">
                                            <label>Discipline</label>
                                            <Select
                                            maxMenuHeight={200}
                                          menuPlacement="auto"  
                                                id="discipline_id"
                                                styles={customStyles}
                                                name="discipline_id"
                                                className="form"
                                                options={discipline.map(disciplines => ({
                                                    value: disciplines.id,
                                                    label: disciplines.discipline_name
                                                }))}
                                                onChange={handleDisciplineChange}
                                            />
                                        </div>
                                        {message ? (
                                            <div className="alert " style={{ width: '50%', margin: 'auto', marginTop: '20px', textAlign: 'center', fontSize: '20px' }}>
                                                {message}
                                            </div>
                                        ) : (
                                            <div className="table-responsive ovrflw">
                                                <div className='row'>
                                                   
                                                    
                                                    
                                                </div>
                                                {Object.keys(groupedBySemester).map(semester => (
                                                    <div key={semester}>
                                                        <div className="syl-fnt">
                                                        <h6>Semester: {semester}</h6>
                                                        </div>
                                                        <table className="display dataTable table-striped table-bordered" ref={tableRef}>
                                                            <thead className="tab-wt">
                                                                <tr className="bg-primary">
                                                                    <th rowSpan="2">Course Code</th>
                                                                    <th rowSpan="2">Title of the Course</th>
                                                                    <th rowSpan="2">Type of the Course</th>
                                                                    <th rowSpan="2">Credit</th>
                                                                    <th rowSpan="2">Course component</th>
                                                                    <th colSpan="4">Hour Distribution / week</th>
                                                                    <th>Action</th>
                                                                </tr>
                                                                <tr className="bg-primary">
                                                                    <th style={{ border: '1px solid white' }}>L</th>
                                                                    <th style={{ border: '1px solid white' }}>T</th>
                                                                    <th style={{ border: '1px solid white' }}>P</th>
                                                                    <th style={{ border: '1px solid white' }}>O</th>
                                                                    <th></th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {groupedBySemester[semester].map((syllabuslistings, index) => (
                                                                    <tr key={syllabuslistings.id}>
                                                                        <td>{syllabuslistings.course_code}</td>
                                                                        <td>{syllabuslistings.course_name}</td>
                                                                        <td>{syllabuslistings.course_discipline_component_code}</td>
                                                                        <td>{syllabuslistings.credit}</td>
                                                                        <td>{syllabuslistings.course_component_id.join(', ')}</td>
                                                                        <td>{syllabuslistings.course_component_code.split(',')[0]}</td>
                                                                        <td>{syllabuslistings.course_component_code.split(',')[1]}</td>
                                                                        <td>-</td>
                                                                        <td>-</td>
                                                                        <td>
                                                                            <ul className="action">
                                                                                <li className="edit">
                                                                                    <Link to={`/admin/courseedit/${encodeID(syllabuslistings.courseid)}`}>
                                                                                        <i className="icon-pencil-alt"></i>
                                                                                    </Link>
                                                                                </li>
                                                                            </ul>
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                ))}
                                                {totalPages > 1 && (
                                                    <nav aria-label="..." style={{ cursor: "pointer" }}>
                                                        <ul className="pagination justify-content-end">
                                                            <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                                                <span className="page-link pgn-clr" onClick={handlePreviousPage}>Previous</span>
                                                            </li>
                                                            {[...Array(totalPages).keys()].map(pageNumber => (
                                                                <li key={pageNumber + 1} className={`page-item ${currentPage === pageNumber + 1 ? 'act-clr' : ''}`}>
                                                                    <span className="page-link pgn-clr" onClick={() => handlePageChange(pageNumber + 1)}>{pageNumber + 1}</span>
                                                                </li>
                                                            ))}
                                                            <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                                                <span className="page-link pgn-clr" onClick={handleNextPage}>Next</span>
                                                            </li>
                                                        </ul>
                                                    </nav>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Template>
        </>
    );
}
